import styled, { css } from 'styled-components/macro';
import { getColor } from 'utils/theme';

const getSizeStyles = props => {
  switch (props.size) {
    case 'large':
      return css`
        font-size: 56px;
        line-height: 64px;
        @media (min-width: 768px) {
          font-size: 72px;
          line-height: 104px;
        }
        @media (min-width: 1600px) {
          font-size: 104px;
          line-height: 136px;
        }
      `;
    case 'sub':
      return css`
        font-size: 32px;
        line-height: 40px;
        @media (min-width: 768px) {
          font-size: 40px;
          line-height: 48px;
        }
        @media (min-width: 1600px) {
          font-size: 48px;
          line-height: 56px;
        }
      `;
    case 'regular':
      return css`
        font-size: 40px;
        line-height: 48px;
        @media (min-width: 768px) {
          font-size: 56px;
          line-height: 64px;
        }
        @media (min-width: 1600px) {
          font-size: 64px;
          line-height: 72px;
        }
      `;
    case 'small':
      return css`
        font-size: 14px;
        line-height: 16px;
        @media (min-width: 768px) {
          font-size: 18px;
          line-height: 22px;
        }
        @media (min-width: 1600px) {
          font-size: 24px;
          line-height: 28px;
        }
      `;
    default:
      return css`
        font-size: 40px;
        line-height: 48px;
        @media (min-width: 768px) {
          font-size: 56px;
          line-height: 64px;
        }
        @media (min-width: 1600px) {
          font-size: 64px;
          line-height: 72px;
        }
      `;
  }
}

const Heading = styled.h1`
  font-family: 'HelveticaNeue', 'Helvetica Neue', Helvetica, Arial, sans-serif !important;
  font-weight: ${props => (props.bold ? 600 : 400)};
  color: ${getColor};
  text-align: ${props => props.align};
  ${getSizeStyles}
`;

Heading.defaultProps = {
  size: 'large',
  color: 'black',
  align: 'left',
  bold: true
};

export default Heading;
